module.exports = __webpack_public_path__ + "img/sf.7ee86a9a.png";